import './types.js'
import { table } from '../../../_constants/Code'
import { getAppMaster, getDynamoDB } from '../../../common/utils/DynamoDbUtils'

/** CompanyConfig の財務データアップロードタスク設定 Key（月次・四半期・年次） */
const ACCOUNTING_UPLOAD_TASK_CONFIG_KEYS = [
  'DataCreationTaskSchedule#monthly#AccountingUploadTask',
  'DataCreationTaskSchedule#quarter#AccountingUploadTask',
  'DataCreationTaskSchedule#year#AccountingUploadTask'
]

/**
 * CompanyConfig から財務データアップロードタスク設定の有無を取得する
 *
 * 月次・四半期・年次のいずれかに設定があれば true。設定なし・取得失敗時は false（財務データを非活性にする）
 *
 * @param {string} corporationNumber
 * @returns {Promise<boolean>}
 */
export async function fetchHasAccountingUploadTask(corporationNumber) {
  try {
    const results = await Promise.all(
      ACCOUNTING_UPLOAD_TASK_CONFIG_KEYS.map((key) =>
        getDynamoDB(table.CompanyConfig, null, corporationNumber, { CorporationNumber: corporationNumber, Key: key })
      )
    )
    return results.some((rows) => Array.isArray(rows) && rows.length > 0)
  } catch (error) {
    console.error('fetchHasAccountingUploadTask:', error)
    return false
  }
}

/**
 * @param {string[]} files
 * @param {string} permissionKey
 * @returns {string[]}
 */
export function toggleGenericDataKindInFilesList(files, permissionKey) {
  if (files.includes(permissionKey)) {
    return files.filter((node) => node !== permissionKey)
  }
  return [...files, permissionKey]
}

/**
 * AppMaster GenericDataKind を取得し camelCase に正規化する
 *
 * @param {string} corporationNumber
 * @returns {Promise<import('./types.js').GenericDataKindItem[]>}
 */
export async function fetchGenericDataKinds(corporationNumber) {
  try {
    const data = await getAppMaster(corporationNumber, { ConfigName: 'GenericDataKind' }, null)
    if (!data || !Array.isArray(data)) {
      return []
    }
    return data
      .map((item) => {
        const genericDataKindCode = item.GenericDataKindCode ?? item.genericDataKindCode ?? ''
        const genericDataKindName = item.GenericDataKindName ?? item.genericDataKindName ?? ''
        const genericDataSuperKindCode = item.GenericDataSuperKindCode ?? item.genericDataSuperKindCode ?? ''
        if (!genericDataKindCode || !genericDataSuperKindCode) {
          return null
        }
        return {
          genericDataKindCode: String(genericDataKindCode),
          genericDataKindName: String(genericDataKindName),
          genericDataSuperKindCode: String(genericDataSuperKindCode)
        }
      })
      .filter(Boolean)
  } catch (error) {
    console.error('fetchGenericDataKinds:', error)
    return []
  }
}

/**
 * AppMaster GenericDataSuperKind を取得し camelCase に正規化する
 *
 * @param {string} corporationNumber
 * @returns {Promise<import('./types.js').GenericSuperKindItem[]>}
 */
export async function fetchGenericSuperKinds(corporationNumber) {
  try {
    const data = await getAppMaster(corporationNumber, { ConfigName: 'GenericDataSuperKind' }, null)
    if (!data || !Array.isArray(data)) {
      return []
    }
    return data
      .map((item) => {
        const genericDataSuperKindCode = item.GenericDataSuperKindCode ?? item.genericDataSuperKindCode ?? ''
        const genericDataSuperKindName = item.GenericDataSuperKindName ?? item.genericDataSuperKindName ?? ''
        if (!genericDataSuperKindCode) {
          return null
        }
        return {
          genericDataSuperKindCode: String(genericDataSuperKindCode),
          genericDataSuperKindName: String(genericDataSuperKindName)
        }
      })
      .filter(Boolean)
  } catch (error) {
    console.error('fetchGenericSuperKinds:', error)
    return []
  }
}
